import "@fortawesome/fontawesome-free/css/all.min.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { ToastProvider } from "./components/shared/ToastMessage";
import "./index.css";
import { queryClient } from "./lib/queryClient";
import { hydrate } from "./lib/theme/store";
import { store } from "./redux";
import { createAppRouter } from "./router";
import { loadDeploymentConfig } from "./services/deploymentConfigService";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = createRoot(rootElement);

async function bootstrap(): Promise<void> {
  hydrate();
  try {
    await loadDeploymentConfig();
    const router = createAppRouter();
    root.render(
      <StrictMode>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <ToastProvider>
              <App router={router} />
            </ToastProvider>
          </QueryClientProvider>
        </Provider>
      </StrictMode>,
    );
  } catch (error) {
    console.error("[Bootstrap] Deployment configuration failed:", error);
    root.render(
      <main className="grid min-h-screen place-items-center bg-background p-6 text-center text-foreground">
        <div>
          <h1 className="text-xl font-semibold">Application unavailable</h1>
          <p className="mt-2 text-muted-foreground">Please try again later.</p>
        </div>
      </main>,
    );
  }
}

void bootstrap();
